<img [src]="thumbnailUrl" [alt]="file.name" class="object-fill w-full thumbnail" appDefaultImg />